const genAnswer = function (qu, value, refItem) {
  const optionList = qu.optionList
  return value.map(item => {
    return {
      descId: refItem.id,
      answer: item,
      otherAnswer: optionList.find(opt => opt.id === item) && optionList.find(opt => opt.id === item).otherValue || ''
    }
  })
}

const setAnswer = function (qu, valueMap, otherAnswerMap, extendsDataMap, answerList = []) {
  const value = []
  const { optionList } = this
  if (answerList.length) {
    answerList.forEach(item => {
      const { answer, otherAnswer } = item
      value.push(answer)
      if (optionList.find(opt => opt.id === answer)) {
        optionList.find(opt => opt.id === answer).otherValue = otherAnswer
      }
    })
    this.value = value
  }
  // 选中答案
  if (valueMap[qu.id] && valueMap[qu.id].length) {
    this.value = valueMap[qu.id]
  }
}

const answer = {
  genAnswer,
  setAnswer
}

export default answer



// WEBPACK FOOTER //
// ./src/components/editor/CheckBox/answer.js